import { Link } from 'react-router-dom';
import { organisationInvestmentLine, organisationLeaderLine } from '../../lib/copy';
import type { InvestorCard, LeaderCard } from './people-groups';

/**
 * **The two rows the People tab is made of** — one for somebody who runs the
 * organisation, one for somebody who put money into it. A row is one person (or
 * fund) with a line under the name for each role or round the record holds.
 *
 * The name is a link only where the office keeps a record: an untracked one has
 * no page, and a link to nothing is worse than plain text because it looks like
 * a way in.
 */

export function LeadershipRow({ leader }: { leader: LeaderCard }) {
  const lines = leader.roles.map(organisationLeaderLine);

  return (
    <li className="org-person">
      {leader.tracked ? (
        <Link className="person" to={`/people/${leader.person_entity_id}`}>
          {leader.display_name}
        </Link>
      ) : (
        <span className="person">{leader.display_name}</span>
      )}
      {lines.map((line, index) => (
        <span key={index} className="org-person-meta">
          {line}
        </span>
      ))}
    </li>
  );
}

/**
 * An investor may be a fund as well as a person, so the link goes to whichever
 * record the office keeps.
 */
export function InvestorRow({ card }: { card: InvestorCard }) {
  const { investor } = card;
  const lines = card.rounds.map(organisationInvestmentLine).filter(Boolean);
  const href =
    investor.kind === 'org'
      ? `/organizations/${investor.entity_id}`
      : `/people/${investor.entity_id}`;

  return (
    <li className="org-person">
      {investor.tracked ? (
        <Link className="person" to={href}>
          {investor.display_name}
        </Link>
      ) : (
        <span className="person">{investor.display_name}</span>
      )}
      {lines.map((line, index) => (
        <span key={index} className="org-person-meta">
          {line}
        </span>
      ))}
    </li>
  );
}
